/**
 * Product Rating Component
 * Fetches and displays product rating with stars and review count
 */

class ProductRating {
  constructor(container) {
    this.ratingContainer = container;
    this.apiUrl = 'https://hjdomxzbruxedccddyna.supabase.co/rest/v1/score?select=*&order=created_at.desc&limit=1';
    this.headers = {
      Authorization:
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
      apikey:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
    };

    this.init();
  }

  init() {
    if (!this.ratingContainer) return;

    this.showLoading();

    // Use requestIdleCallback for non-blocking initialization
    if ('requestIdleCallback' in window) {
      requestIdleCallback(
        () => {
          this.fetchRating();
        },
        { timeout: 2000 }
      );
    } else {
      setTimeout(() => {
        this.fetchRating();
      }, 100);
    }
  }

  showLoading() {
    this.ratingContainer.innerHTML = '<div class="rating-loading">Loading rating...</div>';
  }

  async fetchRating() {
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 10000);

      const response = await fetch(this.apiUrl, {
        headers: this.headers,
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      requestAnimationFrame(() => {
        if (data && data.length > 0) {
          const ratingData = data[0];
          this.renderRating(ratingData.stars, ratingData.numberOfReviews);
        } else {
          this.showNoRating();
        }
      });
    } catch (error) {
      console.error('Error fetching rating:', error);
      requestAnimationFrame(() => {
        this.showError();
      });
    }
  }

  renderRating(stars, numberOfReviews) {
    const starsHTML = this.generateStars(stars);

    this.ratingContainer.innerHTML = `
      <div class="product-rating">
        <div class="rating-stars">
          ${starsHTML}
        </div>
        <span class="rating-count">${numberOfReviews} Reviews</span>
      </div>
    `;
  }

  generateStars(rating) {
    const fullStars = '<span class="star filled">★</span>';
    const emptyStars = '<span class="star empty">☆</span>';
    return fullStars.repeat(rating) + emptyStars.repeat(5 - rating);
  }

  showNoRating() {
    this.ratingContainer.innerHTML = '<div class="rating-no-data">No rating available</div>';
  }

  showError() {
    this.ratingContainer.innerHTML = '<div class="rating-error">Unable to load rating</div>';
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function () {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(
      () => {
        initializeAllProductRatings();
      },
      { timeout: 3000 }
    );
  } else {
    setTimeout(() => {
      initializeAllProductRatings();
    }, 200);
  }
});

// Initialize all product rating components on the page
function initializeAllProductRatings() {
  const ratingContainers = document.querySelectorAll('[data-product-rating]');

  ratingContainers.forEach((container) => {
    new ProductRating(container);
  });
}
